import axios from "@/api/request.js";

/**
 * get请求
 * @author zhouy
 * @param {*} url 请求路径
 * @param {*} parameter 请求参数key=value&key1=value1
 */
export function fun_GetAction(url, parameter) {
  return axios({
    url: url,
    method: "get",
    params: parameter
  });
}

/**
 * post请求
 * @author zhouy
 * @param {*} url 请求路径
 * @param {*} parameter 请求参数{key:value,key1:value1}
 */
export function fun_PostAction(url, data, time) {
  let obj = fun_SplitUrl(url);
  data = data ? Object.assign(data, obj) : obj;
  url = url.indexOf("?") > -1 ? url.substr(0, url.indexOf("?")) : url;
  return axios({
    url: url,
    method: "post",
    data,
    timeout: time
  });
}

/**
 * 处理url参数, 把请求中的get参数转为post参数
 * @author zhouy
 * @param {*} url 处理的url
 * @returns 返回处理后的参数
 */
function fun_SplitUrl(url) {
  let obj = {};
  let i = url.indexOf("?") + 1;
  if (i == 0) {
    return obj;
  }
  let str = url.substr(i);
  let arr = str.split("&");
  for (let i = 0; i < arr.length; i++) {
    let arr1 = arr[i].split("=");
    obj[arr1[0]] = arr1[1];
  }
  return obj;
}

/**
 * put请求, 修改方法
 * @author zhouy
 * @param {*} url 请求路径
 * @param {*} parameter 请求参数{key:value,key1:value1}
 */
export function fun_PutAction(url, parameter) {
  return axios({
    url: url,
    method: "put",
    data: parameter
  });
}

/**
 * delete请求, 删除方法
 * @author zhouy
 * @param {*} url 请求路径
 * @param {*} parameter 请求参数keys=1,2,3
 */
export function fun_DeleteAction(url, parameter) {
  return axios({
    url: url,
    method: "delete",
    data: parameter
  });
}

/**
 * @Description 上传
 * @author 滕威
 * @params data  入参对象
 * @time 2019-12-02
 */
export const fun_UploadImg = (url, data, time) => {
  return axios({
    url,
    method: "post",
    timeout: time,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data
  });
};

/**
 * @Description 下载
 * @author zhouy
 * @params data  入参对象
 * @time 2019-12-02
 */
export const fun_Download = (url, data) => {
  return axios({
    url,
    responseType: "arraybuffer",
    timeout: 0,
    method: "post",
    data
  });
};

/**
 * @Description 验证码
 * @author 滕威
 * @params url  请求url
 * @params params  参数
 * @time 2021-01-14
 */
export const fun_GetImgCode = (url, params) => {
  return axios({
    url: `${url}`,
    responseType: "arraybuffer", // 类型
    method: "get",
    params
  });
};

/**
 * PDF文件路径
 * @author shuhua
 * @param {*} url 文件路径
 */
export function fun_PDFPreview(url) {
  // pdf文件路径
  let src =
    `${window.location.origin}` + "/brs-server/pdf/load?filePath=" + url;
  // "http://localhost:8080/whebd-server/pdf/load?filePath=" + url;
  return src;
}

/**
 * post请求
 * @author zhouzhou
 * @param {*} url 请求路径
 * @param {*} parameter 请求参数{key:value,key1:value1}
 */
export function fun_PostActionJson(url, data, time) {
  let obj = fun_SplitUrl(url);
  data = data ? Object.assign(data, obj) : obj;
  url = url.indexOf("?") > -1 ? url.substr(0, url.indexOf("?")) : url;
  return axios({
    url: url,
    method: "post",
    data,
    timeout: time,
    headers: {
      "Content-Type": "application/json"
    },
  });
}
